<template>
  <Add ref="modalRef" :busy="busy" @add:items="handleAddItems">
    <slot />
  </Add>
</template>

<script setup>
import { computed, ref } from "vue";
import { Add } from "@/SharedComponents/Checklist";
import { useTaskChecklist } from "@/Composables/useTaskChecklist";

const props = defineProps({
  task: { type: Object, required: true },
});

const { busy, addChecklist } = useTaskChecklist(computed(() => props.task));

async function handleAddItems(items) {
  addChecklist({
    items: items.map((item) => ({
      description: item,
    })),
  });
}

const modalRef = ref(null);

function openModal() {
  modalRef.value?.openModal();
}

defineExpose({
  openModal,
});
</script>
